import React, { useState , useEffect} from "react";
import "./affiliate-dashboard.css";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";

  const columns = [
    {
      name: "Name",
      selector: (row) => row.name,
      sortable: true,
     
    },
    {
      name: "Email",
      selector: (row) => row.email,
      sortable: true,
    
    },
    {
      name: "Sign Up Package",
      selector: (row) => row.packageName ?? "",
      sortable: true,
     
    },
    {
      name: "Action",
      selector: (row) => row.actions,
      sortable: true,
    
    }
  ];
  
  const customStyles = {
    header: {
      style: {
        minHeight: "56px",
      },
    },
    headRow: {
      style: {
        borderTopStyle: "solid",
        borderTopWidth: "1px",
      },
    },
    headCells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
        fontSize: "17px",
        color: "#004aad",
      },
    },
  
    cells: {
      style: {
        "&:not(:last-of-type)": {
          borderRightStyle: "solid",
          borderRightWidth: "1px",
        },
        fontSize: "16px",
      },
    },
  };
  
const AffiliateTable = (props) => {

    

    const [tabledata,setTabledata] = useState([])
 
    const setData = () => {   

     setTimeout(() => {
      setTabledata(props.users)
     }, 500);
    
    }
    useEffect(()=>{
      setData()
      console.log(props.users,"table")
    },[])
    return (

        <div className="chart_partts">
            <h2>My Affiliates</h2>
           
  
            <DataTable
                columns={columns}
                data={props.users}
                //pagination
                striped
                responsive
                customStyles={customStyles}
                subHeaderAlign="right"
                subHeaderWrap
                //paginationDefaultPage={page}
                pagination
                //paginationTotalRows={pagination.totalRows}
                //paginationPerPage={limit}
                //paginationRowsPerPageOptions={[10, 15, 20, 40]}
                //onChangeRowsPerPage={handlePerRowsChange}
                //onChangePage={changePage}
                //progressComponent={<CustomLoader />}
                //noDataComponent={<EmptyDataLoader />}
              />
        </div>
        );
    };
    export default AffiliateTable;